import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_DxpShopifyImg = _resolveComponent("DxpShopifyImg")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  "data-testid": "purchase-order-close-items-modal-back-btn",
                  onClick: _ctx.closeModal
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "icon-only",
                      icon: _ctx.arrowBackOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.translate("Close purchase order items")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_buttons, {
              slot: "end",
              onClick: _ctx.selectAllItems
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  "data-testid": "purchase-order-close-items-select-all-btn",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate("Select all")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { "data-testid": "purchase-order-close-items-modal-content" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_item, { lines: "none" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_list_header, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.translate("To close the purchase order, select all.")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPOItems(), (item, index) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                button: _ctx.isPOItemStatusPending(item),
                key: index,
                "data-testid": `purchase-order-close-items-row-${item.orderItemSeqId || item.productId}`,
                onClick: ($event: any) => (item.isChecked = !item.isChecked)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxpShopifyImg, {
                        size: "small",
                        src: _ctx.getProduct(item.productId).mainImageUrl
                      }, null, 8, ["src"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(item.productId)) ? _ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(item.productId)) : _ctx.getProduct(item.productId).productName), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.secondaryId, _ctx.getProduct(item.productId))), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.getFeatures(_ctx.getProduct(item.productId).productFeatures)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_buttons, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_checkbox, {
                        "aria-label": "itemStatus",
                        slot: "end",
                        "data-testid": `purchase-order-close-items-select-checkbox-${item.orderItemSeqId || item.productId}`,
                        modelValue: _ctx.isPOItemStatusPending(item) ? item.isChecked : true,
                        disabled: _ctx.isPOItemStatusPending(item) ? false : true
                      }, null, 8, ["data-testid", "modelValue", "disabled"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["button", "data-testid", "onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_fab, {
      vertical: "bottom",
      horizontal: "end",
      slot: "fixed"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_fab_button, {
          "data-testid": "purchase-order-close-items-save-btn",
          disabled: !_ctx.hasPermission(_ctx.Actions.APP_SHIPMENT_UPDATE) || !_ctx.isEligibleToClosePOItems(),
          onClick: _ctx.confirmSave
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_icon, { icon: _ctx.saveOutline }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _: 1
    })
  ], 64))
}